import {
  AUTH_LOGIN,
  RESET_PASSWORD_REQUEST,
  ORG_REGISTER,
  USER_REGISTER,
  GET_CURRENT_USER_DETAILED_ACCESS,
  AUTH_LOGOUT,
} from "../../../api/ApiEndpoints";
import api from "../../../interceptor/Interceptor";
// import { storeAuthData } from "../../../utils/helpers";
import {
  fetchLoginUserStart,
  fetchLoginUserSuccess,
  fetchLoginUserFailure,
  forgotPasswordStart,
  forgotPasswordSuccessAction,
  forgotPasswordFailure,
  registerOrgStart,
  registerOrgSuccessAction,
  registerOrgFailure,
  logoutUserStart,
  logoutUser as logoutUserAction,
    checkSessionInconclusive,
} from "../../reducer/authReducer/AuthReducer";

let isPostLoginUser = false;
let isPostForgotPassword = false;
let isPostRegisterOrg = false;
let isCheckingSession = false;
let isPostLogout = false;

const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export const checkSession = () => async (dispatch) => {
  if (isCheckingSession) return;
  isCheckingSession = true;
  dispatch(fetchLoginUserStart());

  try {
    const response = await api.get(GET_CURRENT_USER_DETAILED_ACCESS);
    const { user } = response.data;
    dispatch(fetchLoginUserSuccess({ user, permissions: [] }));
    return { success: true };
  } catch (error) {
    const status = error?.response?.status;

    if (status === 401) {
      dispatch(logoutUserAction());
    } else {
      dispatch(checkSessionInconclusive()); // <-- changed from fetchLoginUserFailure(null)
    }
    return { success: false };
  } finally {
    isCheckingSession = false;
  }
};

// .................... Logout ...........................

export const logoutUser = () => async (dispatch) => {
  if (isPostLogout) return;
  isPostLogout = true;
  dispatch(logoutUserStart());

  try {
    await api.post(AUTH_LOGOUT);
  } catch (error) {
  } finally {
    dispatch(logoutUserAction());
    isPostLogout = false;
  }
};

// .................... Email / Password Login ...........................

export const loginUser = (email, password) => async (dispatch) => {
  if (isPostLoginUser) return;
  isPostLoginUser = true;
  dispatch(fetchLoginUserStart());

  try {
    const response = await api.post(AUTH_LOGIN, { email, password });
    const { user } = response.data;

    dispatch(fetchLoginUserSuccess({ user, permissions: [] }));

    return { success: true, data: response.data };
  } catch (error) {
    const payload = error?.response?.data?.error || {
      message: extractErrorMessage(error, "Login failed"),
    };
    dispatch(fetchLoginUserFailure(payload));
    return { success: false, error: payload };
  } finally {
    isPostLoginUser = false;
  }
};

// .................... Forgot Password ...........................

export const sendPasswordResetToken = (email) => async (dispatch) => {
  if (isPostForgotPassword) return;
  isPostForgotPassword = true;
  dispatch(forgotPasswordStart());

  try {
    const response = await api.post(RESET_PASSWORD_REQUEST, { email });
    dispatch(forgotPasswordSuccessAction());
    return { success: true, data: response.data };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      "Failed to send password reset email",
    );
    dispatch(forgotPasswordFailure(message));
    return { success: false, error: message };
  } finally {
    isPostForgotPassword = false;
  }
};

// .................... Register Organization + Admin User ...........................

export const registerOrganization = (orgForm) => async (dispatch) => {
  if (isPostRegisterOrg) return;
  isPostRegisterOrg = true;
  dispatch(registerOrgStart());

  try {
    const orgResponse = await api.post(ORG_REGISTER, {
      name: orgForm.orgName,
      email: orgForm.email,
      address: orgForm.address,
      taxId: orgForm.taxId,
      premiumMember: false,
    });

    try {
      const userResponse = await api.post(USER_REGISTER, {
        email: orgForm.email,
        name: orgForm.userName,
        admin: true,
        contactNumber: orgForm.contactNumber,
        designation: orgForm.designation,
        address: orgForm.address,
        organizationId: orgResponse.data.organizationId,
      });

      dispatch(registerOrgSuccessAction());
      return { success: true, data: userResponse.data };
    } catch (userError) {
      const message = extractErrorMessage(
        userError,
        "Organization created, but failed to register the admin user.",
      );
      dispatch(registerOrgFailure(message));
      return { success: false, error: message };
    }
  } catch (orgError) {
    const message = extractErrorMessage(
      orgError,
      "Failed to register organization",
    );
    dispatch(registerOrgFailure(message));
    return { success: false, error: message };
  } finally {
    isPostRegisterOrg = false;
  }
};
